import {
    MERCHANT_TRANS_SETTINGS_LIST_INITIATED,
    MERCHANT_TRANS_SETTINGS_FAILED,
    MERCHANT_TRANS_SETTINGS_LIST_LOADED,
  } from "../actions/MerchantTransSettingsAction";
  
  const initialState = {
    listdata: [],
    data: [],
    loading: false,
    error: null
  };
  
  const MerchantReducer = (state = initialState, action) => {
    switch (action.type) {
      case MERCHANT_TRANS_SETTINGS_LIST_INITIATED:
        return {
          ...state,
          data : {},
          loading: true,
          error: null,
        };
      case MERCHANT_TRANS_SETTINGS_LIST_LOADED:
        return {
          ...state,
          loading: false,
          data : action.payload,
      };
      case MERCHANT_TRANS_SETTINGS_FAILED:
          return { ...state, loading: false, error: action.payload };
      default:
        return state;
    }
  };
  
  export default MerchantReducer;